var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.user)?_c('div',{staticClass:"ecommerce-landing-page"},[_c('Intro'),_c('Customers'),_c('JoinNow'),_c('HowItWork'),_c('JoinedShops'),_c('UsersOpinion'),_c('Strategy')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }